module.exports = __webpack_public_path__ + "static/media/example-3.0b8cdc36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Offer/example-3.jpg
// module id = 400
// module chunks = 0